import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const RolesSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/RolesSettings"));
const SectionsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/SectionsSettings"));
const PermissionsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/PermissionsSettings"));
const MenuSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/MenuSettings"));
const TestingTopicsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingTopicsSettings"));
const TestingDocumentsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingDocumentsSettings"));
const TestingMaterialsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingMaterialsSettings"));
const TestingOverviewSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingOverviewSettings"));
const TestingTagsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingTagsSettings"));
const TestingHowItWorksSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingHowItWorksSettings"));
const TestingQuestionsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingQuestionsSettings"));
const TestingTestsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingTestsSettings"));
const TestingAssignmentsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingAssignmentsSettings"));
const TestingProgressResultsSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TestingProgressResultsSettings"));
const ResultFileIssuesSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/ResultFileIssuesSettings"));
const OrderB24StatusMismatchesSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/OrderB24StatusMismatchesSettings"));
const TicketNotificationSettings = lazy(() => import("@/pages/ControlPanel/Nested/Settings/TicketNotificationSettings"));

const urlsConfig = new UrlsConfig();

export function settingsRoutes() {
    return (
      <>
          <Route path={urlsConfig.rolesSettings.to} element={<RolesSettings/>}/>
          <Route path={urlsConfig.sectionsSettings.to} element={<SectionsSettings/>}/>
          <Route path={urlsConfig.permissionsSettings.to} element={<PermissionsSettings/>}/>
          <Route path={urlsConfig.menuSettings.to} element={<MenuSettings/>}/>
          <Route path={urlsConfig.testingTopicsSettings.to} element={<TestingTopicsSettings/>}/>
          <Route path={urlsConfig.testingDocumentsDesign.to} element={<TestingDocumentsSettings/>}/>
          <Route path={urlsConfig.testingMaterialsDesign.to} element={<TestingMaterialsSettings/>}/>
          <Route path={urlsConfig.testingOverviewSettings.to} element={<TestingOverviewSettings/>}/>
          <Route path={urlsConfig.testingTagsSettings.to} element={<TestingTagsSettings/>}/>
          <Route path={urlsConfig.testingQuestionsSettings.to} element={<TestingQuestionsSettings/>}/>
          <Route path={urlsConfig.testingTestsSettings.to} element={<TestingTestsSettings/>}/>
          <Route path={urlsConfig.testingAssignmentsSettings.to} element={<TestingAssignmentsSettings/>}/>
          <Route path={urlsConfig.testingProgressResultsSettings.to} element={<TestingProgressResultsSettings/>}/>
          <Route path={urlsConfig.testingHowItWorksSettings.to} element={<TestingHowItWorksSettings/>}/>
          <Route path={urlsConfig.resultFileIssuesSettings.to} element={<ResultFileIssuesSettings/>}/>
          <Route path={urlsConfig.orderB24StatusMismatchesSettings.to} element={<OrderB24StatusMismatchesSettings/>}/>
          <Route path={urlsConfig.ticketNotificationSettings.to} element={<TicketNotificationSettings/>}/>
      </>
    );
}
